import { FileCard } from './file-card';

type FileUploadListProps = {
  files: File[];
  removeFile: (index: number) => void;
};

export const FileUploadList = ({ files, removeFile }: FileUploadListProps) => {
  return (
    <div className="space-y-2">
      <h4 className="text-sm font-medium text-gray-700">Selected Files</h4>
      <div className="space-y-1">
        {files.map((file, index) => (
          <FileCard
            key={`${file.name}-${file.size}-${file.lastModified}`}
            file={file}
            removeFile={removeFile}
            index={index}
          />
        ))}
      </div>
    </div>
  );
};
